import { createFileRoute } from '@tanstack/react-router';

import { Error403 } from '@@containers/App/Error403';

export const Route = createFileRoute('/403')({
    component: Error403,
});
